import axios from "axios";
import { Config } from "@/core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/notification/provider`;

export const providerService = {
    createAsync: async function (params: any) {
        return axios.post(`${GATEWAY_URL}`, params)
            .then((response) => {
                return response.data;
            });
    },
    updateAsync: async function (id: any, params: any) {
        return axios.put(`${GATEWAY_URL}/${id}`, params)
            .then((response) => {
                return response.data;
            });
    },
    get: async function (id: any) {
        return axios.get(`${GATEWAY_URL}`, {
            params: { id }
        })
            .then((response) => {
                return response.data;
            });
    },
    getListAsync: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/list`, {
            params
        })
            .then((response) => {
                return response.data;
            });
    },
}